// @todo add story

import LogoutButton from './LogoutButton';

export default LogoutButton;
